import { createAction, emptyProps, props } from '@ngrx/store';

export enum ComponentsActions {
  TOGGLE_MENU = '[Menu] Toggle menu',
  SHOW_SUCCESS_MESSAGE = '[Message] Show success message',
  SHOW_ERROR_MESSAGE = '[Menu] Show error message'
}

export const toggleMenu = createAction(ComponentsActions.TOGGLE_MENU, emptyProps);
export const addSuccessMessage = createAction(ComponentsActions.SHOW_SUCCESS_MESSAGE, props<{
  payload: { title?: string, detail: string }
}>());
export const addErrorMessage = createAction(ComponentsActions.SHOW_ERROR_MESSAGE, props<{
  payload: { title?: string, detail: string }
}>());
